import { ENEMIES } from '../../data/enemies';
import { GROUND_Y, SIM_HZ } from '../../data/tuning';
import { CEILING_Y } from '../player';
import { PLAYER_HITBOX } from '../../data/tuning';

/**
 * EN-03 Avioneta sicaria (GDD §8.2, issue #85). Waits where the level puts it until the INTERCEPT warning
 * (#83) fires, locks the height the pilot has at that tick and then flies straight to the left at the scroll
 * speed plus 4 u/s, keeping that height. Nobody is destroyed: it leaves the screen on the left.
 */
export const EN03 = ENEMIES['EN-03'];

/** The highest and lowest centres the pilot can reach: the locked height always lies in that band. */
const LOWEST = GROUND_Y + PLAYER_HITBOX.height / 2;

/** The height the plane locks: the pilot's, clamped to the band the pilot can fly in. */
export function lockHeight(pilotY: number): number {
  return Math.min(CEILING_Y, Math.max(LOWEST, pilotY));
}

/** Horizontal position after one tick of flight (world coordinates, to the left). */
export function stepHitmanPlane(x: number): number {
  return x - EN03.extraSpeed / SIM_HZ;
}
